export default __webpack_public_path__ + "f8a9edfea6a4de01dbf6824b44737481.svg";